import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { readUserAuthFromLocalStorage, setUserAuth } from 'src/app/core/http/user-auth';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { EStore } from 'src/app/project/shared/enums/store.enum';
import { UpdateUserTwoFactorAuthentication } from '../../user/user.actions';
import { TUser } from '../../user/user.model';
import { UpdateTwoFactorAuthentication } from './two-factor-authentication-state.actions';
import { TTwoFactorAuthenticationState } from './two-factor-authentication-state.model';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorAuthenticationStateService {
  constructor(
    private store: Store<{
      [EStore.USER]: TUser;
      [EStore.TWO_FACTOR_AUTHENTICATION]: TTwoFactorAuthenticationState;
    }>,
    private featureFlagService: FeatureFlagService,
  ) {}

  getState$(): Observable<TTwoFactorAuthenticationState> {
    if (!this.isCurrentUserEndpointEnabled()) {
      return this.store.pipe(
        select(EStore.USER),
        map((user) => ({ enabled2fa: user.enabled2fa, setup2faAfter: user.setup2faAfter })),
      );
    }

    return this.store.pipe(select(EStore.TWO_FACTOR_AUTHENTICATION));
  }

  update(state: TTwoFactorAuthenticationState): void {
    const userAuth = readUserAuthFromLocalStorage();

    setUserAuth({
      ...userAuth,
      twoFactorAuthentication: { ...userAuth.twoFactorAuthentication, ...state },
    });
    this.store.dispatch(new UpdateTwoFactorAuthentication(state));

    if (!this.isCurrentUserEndpointEnabled()) {
      this.store.dispatch(new UpdateUserTwoFactorAuthentication({ enabled2fa: state.enabled2fa }));
    }
  }

  private isCurrentUserEndpointEnabled(): boolean {
    return this.featureFlagService.getFlag(EFeatureFlag.GET_CURRENT_USER_ENDPOINT);
  }
}
